var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMercleWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153,
    height: 28,
    viewBox: "0 0 153 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_285_1670",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 153,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.114 0H0.884766V28H152.114V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_285_1670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9685 0V11.7936H10.5947V0H17.9685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0391 5.53418V13.3235H0.884766V5.53418H25.0391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4243 11.4385C20.6582 14.0803 25.0418 20.2591 25.0418 27.4449H17.2524C17.2524 23.6649 15.052 20.3884 11.8652 18.8277",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2604 10.0674H10.471C10.471 15.3528 6.17023 19.6537 0.884766 19.6537V27.4431C10.4641 27.4431 18.2587 19.6502 18.2587 10.0691L18.2604 10.0674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.589 17.9885L147.445 13.8118C146.079 10.5853 142.318 9.15231 139.123 10.1904C136.071 11.182 133.787 14.5395 134.589 17.9885ZM151.989 15.4586L135.507 20.8147C137.424 23.7843 140.723 25.0156 143.776 24.0241C146.109 23.2653 147.909 21.3529 148.382 18.8955L152.117 17.6815C151.881 22.2098 148.995 26.0366 144.722 27.4247C139.121 29.244 133.013 25.8416 131.315 20.6147C129.307 14.4343 132.646 8.58497 137.924 6.87085C143.777 4.96877 149.677 7.97279 151.499 13.5876C151.694 14.1877 151.879 14.7533 151.989 15.4586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.383 27.4792H124.521V0H128.383V27.4792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.313 20.6841H122.62C120.986 25.3263 117.05 27.9992 112.482 27.9992C106.578 27.9992 101.936 23.2466 101.936 17.3783C101.936 11.1771 106.43 6.34863 112.444 6.34863C117.123 6.34863 121.394 9.28193 122.62 13.7379H118.351C117.199 11.3237 115.341 9.87515 112.556 9.87515C108.509 9.87515 105.798 12.9568 105.798 17.1541C105.798 21.3513 108.583 24.4693 112.482 24.4693C115.119 24.4693 117.235 23.0586 118.313 20.6823V20.6841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7778 27.4802H91.915V6.90736H95.5174V8.62664C95.5174 8.65596 95.5398 8.67837 95.5692 8.67837C95.5829 8.67837 95.5967 8.67319 95.607 8.66114C97.3073 6.85907 99.5319 6.34863 102.291 6.34863V10.3218C98.5748 10.3218 95.7761 10.8943 95.7761 15.9297V27.4784L95.7778 27.4802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6434 18.0138L85.2872 13.9061C83.9265 10.6779 80.2137 9.22939 77.0718 10.2503C74.0697 11.2263 71.8348 14.5666 72.6434 18.0138ZM89.7724 15.572L73.5625 20.8385C75.4664 23.8114 78.7205 25.0582 81.7228 24.0821C84.0179 23.3354 85.7821 21.435 86.2357 18.9847L89.9087 17.7914C89.6984 22.3111 86.8737 26.117 82.6711 27.4827C77.1616 29.2728 71.1278 25.8445 69.4308 20.6176C67.4218 14.4373 70.6845 8.61376 75.8769 6.92724C81.633 5.05621 87.4582 8.08435 89.2828 13.6992C89.4775 14.2993 89.6622 14.8649 89.7742 15.5702L89.7724 15.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2051 27.5172H33.2354L39.8192 10.1037C40.6401 7.71357 41.9973 6.22881 44.834 6.22881C47.988 6.22881 49.5625 8.05846 49.5625 10.7814V23.1457C49.5625 23.858 50.0056 24.3201 50.6316 24.3201C51.2007 24.3201 51.6422 23.9803 51.8267 23.4509L56.9965 10.0985C57.8174 7.71528 59.1677 6.22363 62.0061 6.22363C65.1601 6.22363 66.7346 8.05328 66.7346 10.7762V27.5069H62.984V10.9659C62.984 10.2209 62.5407 9.75704 61.9096 9.75704C61.375 9.75704 60.9335 10.1295 60.7438 10.6555L55.5739 24.0079C54.753 26.3911 53.3684 27.8828 50.5299 27.8828C47.4104 27.8828 45.8359 26.0532 45.8359 23.2957V10.9659C45.8359 10.2209 45.3651 9.75704 44.7323 9.75704C44.1632 9.75704 43.7838 10.1295 43.5665 10.6555L37.2016 27.5104L37.2068 27.5155L37.2051 27.5172Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercleWhite);
export default __webpack_public_path__ + "static/media/mercle-white.a708fec7c4b7d0916f681b024313e8f7.svg";
export { ForwardRef as ReactComponent };